/* ==========================================================================
   NEU INK B2B PDP — 左栏预览控制
   --------------------------------------------------------------------------
   左栏只有两个状态，分界线是“客户到底传图了没有”：
     ① 未传图 → 我们的 .nb-stage，显示 Shopify 商品图，换颜色跟着换
     ② 已传图 → Teeinblue 自己的图库，它展示定制效果且自带变体跟随

   【核心真相 —— 踩了很久才找到】
   Teeinblue（by Shopify Products）会把它自己的图库 .tee-gallery-content
   **注入到 .nb-left 里当第一个子元素，并把我们的 .nb-stage 藏掉**。
   所以新访客看到的是 campaign 的示例设计，而不是商品图 ——
   这不是我们克隆逻辑的错，之前改克隆怎么改都没用。
   现在不再克隆，改成按状态切换谁占左栏（样式在 neuink-b2b-chrome.css）。

   【变体广播 —— Teeinblue 官方（Aslan）确认的契约】
   Teeinblue 靠读表单隐藏字段 input[name="id"] 判断该加载哪张 mockup，
   不是看客户点了哪个按钮。我们不走原生变体选择器，必须手动同步。
   又因为允许一次填多尺码，“当前变体”有歧义（Navy 对 M/L/XL 三个 ID），
   用当前颜色的第一个尺码当代表即可 —— artwork 按颜色切分、尺码共用。
   ========================================================================== */
(function () {
  'use strict';

  function measureChrome() {
    var h = document.querySelector('.nbh-header')
         || document.querySelector('sticky-header.header-wrapper')
         || document.querySelector('.header-wrapper')
         || document.querySelector('.header');
    var px = h ? Math.round(h.getBoundingClientRect().height) : 74;
    if (!px) px = 74;
    var root = document.documentElement;
    root.style.setProperty('--nb-header-h', px + 'px');
    root.style.setProperty('--nb-sticky-top', (px + 16) + 'px');
  }

  /* 客户到底传图了没有：只看不以 _ 开头的字段（_ 开头是内部字段）。
     上传前 Teeinblue 根本不会渲染 properties[Upload Photo] 这个 input。 */
  function hasArtwork() {
    var fields = document.querySelectorAll('[name^="properties["]');
    for (var i = 0; i < fields.length; i++) {
      if (/^properties\[_/.test(fields[i].name)) continue;
      if (fields[i].value) return true;
    }
    return false;
  }

  function init() {
    var root = document.querySelector('.nb-pdp');
    if (!root) return;

    measureChrome();
    window.addEventListener('resize', measureChrome);
    window.setTimeout(measureChrome, 800);
    window.setTimeout(measureChrome, 2000);

    var stage = root.querySelector('[data-nb="stage"]');
    var placeholder = stage ? stage.querySelector('[data-nb="stage-placeholder"]') : null;

    var D = null;
    try { D = JSON.parse(root.querySelector('[data-nb-data]').textContent); } catch (e) {}

    /* ============ 状态切换：谁占左栏 ============ */
    var lastState = null;
    function applyState() {
      var on = hasArtwork();
      if (on === lastState) return;
      lastState = on;
      root.classList.toggle('nb-has-artwork', on);
      console.log('[nb-preview] left column →', on ? 'Teeinblue 定制预览' : 'Shopify 商品图');
    }
    applyState();
    window.setInterval(applyState, 700);

    /* ============ 变体广播 ============ */
    function firstVariantOfColor(color) {
      if (!D) return null;
      for (var i = 0; i < D.variants.length; i++) {
        if (D.variants[i].available && (!color || D.variants[i].color === color)) return D.variants[i];
      }
      return null;
    }

    function broadcastVariant(variantId) {
      if (!variantId) return;
      var hf = root.querySelector('.nb-hookform');
      var inp = hf ? hf.querySelector('[name="id"]') : null;
      if (inp && String(inp.value) !== String(variantId)) {
        inp.value = variantId;
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
      document.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true, detail: { variantId: variantId }
      }));
      var tib = window.teeinblue;
      if (tib && typeof tib.setVariantId === 'function') {
        try { tib.setVariantId(variantId); } catch (e) {}
      }
      console.log('[nb-preview] active variant →', variantId);
    }

    function currentColor() {
      var b = root.querySelector('.nb-color[aria-pressed="true"]');
      return b ? (b.textContent || '').trim() : null;
    }

    /* ============ 颜色 → Shopify 商品图（仅未传图状态用）============ */
    var colorImage = {};
    function applyColorImage(color) {
      var src = colorImage[color];
      var img = placeholder ? placeholder.querySelector('img') : null;
      if (src && img) { img.src = src; img.srcset = ''; }
    }

    if (D && D.handle) {
      fetch('/products/' + D.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          (p.variants || []).forEach(function (v) {
            var color = v.option2 || v.option1;
            if (!color) return;
            if (!colorImage[color] && v.featured_image && v.featured_image.src) {
              colorImage[color] = v.featured_image.src;
            }
          });
          var n = Object.keys(colorImage).length;
          console.log('[nb-preview] variant images bound:', n ? colorImage : '(none bound in Shopify yet)');
          applyColorImage(currentColor());
        })
        .catch(function (e) { console.warn('[nb-preview] product.js fetch failed', e); });
    }

    /* ============ 换颜色 ============ */
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.nb-color') : null;
      if (!b) return;
      var color = (b.textContent || '').trim();
      var v = firstVariantOfColor(color);
      if (v) broadcastVariant(v.id);   // Teeinblue 靠这个切 mockup
      applyColorImage(color);          // 未传图状态下的商品图
    });

    // 页面初始：把默认颜色的变体也广播一次，别让 Teeinblue 自己猜
    window.setTimeout(function () {
      var v = firstVariantOfColor(currentColor());
      if (v) broadcastVariant(v.id);
    }, 1500);

    window.nbPreviewDebug = {
      hasArtwork: hasArtwork,
      state: function () { return root.classList.contains('nb-has-artwork') ? 'teeinblue' : 'shopify-image'; },
      colorImage: function () { return colorImage; }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
